export default __webpack_public_path__ + "static/media/sz_EntrancePlaza.ca4e3819.svg";